import { IUpdateable } from 'src/pods/system/interfaces';
import { updater } from 'src/utils/ObjectUpdater';

import JournalModel from 'src/pods/journals/models/JournalModel';
import PractitionerModel from '../../user/models/PractitionerModel';
import UserModel from 'src/pods/user/models/UserModel';
import ResultModel from './ResultModel';
import QuestionarieModel from 'src/pods/sessions/models/QuestionarieModel';

import { PractitionerSessionStatus } from 'src/enums/session.status';
import { statusListOptions } from '../components';
import KitModel from 'src/pods/warehousing/models/KitModel';

export default class SessionModel implements IUpdateable<SessionModel> {
    public createdAt!: string | Date;
    public id!: number;
    public journal!: JournalModel;
    public practitioner!: PractitionerModel;
    public practitionerID!: number;
    public status!: PractitionerSessionStatus;
    public updatedAt!: string | Date;
    public userID!: number;
    public user!: UserModel;
    public questionnaires!: QuestionarieModel[];
    public results!: ResultModel[];
    public kitID!: number;
    public kit!: KitModel;
    public requestedByPractitioner!: boolean;
    public rescheduledByPractitioner!: boolean;
    public bookingTime!: Date;

    constructor(args?: Partial<SessionModel>) {
        Object.assign(this, args);
        this.journal = new JournalModel(args?.journal);
        this.user = new UserModel(args?.user);
        this.questionnaires = args?.questionnaires ? args.questionnaires : [];
        this.results = args?.results ? args.results : [];
    }

    public update(obj: Partial<SessionModel>): SessionModel {
        return updater.update(this, obj);
    }

    public get statusOptionItemByStatus() {
        return statusListOptions.filter((x) => x.value === this.status)[0];
    }
}
